$(window).scroll(function(){
  if ($(window).scrollTop() > 130) {
    $('.header').addClass('scrollHeader');
    $('.header_client').addClass('scrollHeaderClient');
  }
  else {
    $('.header').removeClass('scrollHeader');
    $('.header_client').removeClass('scrollHeaderClient');
  }
});


// WEBPACK FOOTER //
// ./app/assets/js/scrollHeader.js